import { defineStore } from 'pinia';
import { IFeConfigDTO, ISessionResultDTO } from '@/models/global.models'
import { IUserInfoVO } from '@/models/user.models'
import { IUserResourcesVO } from '@/models/merchant.models';
interface PermitResources {
    page: {
        [key: string]: IUserResourcesVO;
    };
    btn: {
        [key: string]: IUserResourcesVO;
    };
}
export const useGlobal = defineStore({
    id: 'global',
    state: () => {
        return {
            // 强类型demo，按需更改自己项目中的类型
            sessionKey: '',
            userId: 0,
            openId: '',
            // category: ICategoryDTO[] = [];
            feConfig:  {
                /** 节假日枚举 */
                holidaysEnum: [],
                specialCategoryIds: [],
                /** 使用范围枚举 */
                useScopeEnum: [],
                /** 星期枚举 */
                weekEnum: [],
                agreementUrl: '',
                refundTypes: {},
            } as IFeConfigDTO,
            userInfo: {} as IUserInfoVO,
            userResources: {
                page: {},
                btn: {}
            } as PermitResources,
        };
    },
    actions: {
        setFeConfig(payload: IFeConfigDTO) {
            this.feConfig = payload;
        },
        setUserData(payload: ISessionResultDTO) {
            this.sessionKey = payload.sessionKey;
            this.userId = payload.userId;
            this.openId = payload.openId;
        },
        setUserInfo(payload: IUserInfoVO) {
            this.userInfo = payload
        },
        setUserResources(payload: IUserResourcesVO[]) {
            const page: { [key: string]: IUserResourcesVO } = {};
            const btn: { [key: string]: IUserResourcesVO } = {};
            payload.forEach(item => {
                if (item.resourceType === 1) {
                    // 按钮
                    btn[item.resourceKey] = item;
                } else if (item.resourceType === 2) {
                    // 页面
                    page[item.resourceKey] = item;
                }
            });
            this.userResources = {
                page,
                btn
            }
        },
    },
});
